import { useCallback, useEffect, useState } from 'react';
import { toApiError } from '../api/axiosClient';

/**
 * Small data-fetch hook giving every screen the same loading / error / reload
 * shape. `fetcher` is an async function; `deps` re-runs it when they change.
 * Returns { data, loading, error, reload, setData }.
 */
const useApiData = (fetcher, deps = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableFetcher = useCallback(fetcher, deps);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await stableFetcher();
      setData(result);
    } catch (err) {
      setError(toApiError(err));
    } finally {
      setLoading(false);
    }
  }, [stableFetcher]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load, setData };
};

export default useApiData;
